import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { Capacitor, PluginListenerHandle } from '@capacitor/core';
import { Keyboard } from '@capacitor/keyboard';
import { User } from '../../models/user';
import { AuthService } from '../../services/auth.service';
import { ShoppingCartService } from '../../services/shopping-cart.service';
import { PictureComponent } from '../picture/picture.component';

@Component({
    selector: 'app-footer-mobile',
    templateUrl: './footer-mobile.component.html',
    styleUrls: ['./footer-mobile.component.scss'],
    imports: [CommonModule, CommonModule, PictureComponent, RouterLink, RouterLinkActive],
})
export class FooterMobileComponent implements OnInit, OnDestroy {
    user: User;
    shoppingCartLineCount: number = 0;
    keyboardOpen = false;

    private keyboardShowHandle?: PluginListenerHandle;
    private keyboardHideHandle?: PluginListenerHandle;

    constructor(
        private readonly authService: AuthService,
        private readonly shoppingCartService: ShoppingCartService,
    ) {}

    ngOnInit() {
        this.authService.userLoggedIn.subscribe({
            next: (user) => {
                this.user = user;
            },
        });
        this.shoppingCartService.shoppingCart.subscribe((shoppingCart) => {
            if (shoppingCart) {
                this.shoppingCartLineCount = shoppingCart.count;
            }
        });
        void this.registerKeyboardListeners();
    }

    ngOnDestroy() {
        void this.keyboardShowHandle?.remove();
        void this.keyboardHideHandle?.remove();
    }

    private async registerKeyboardListeners() {
        if (!Capacitor.isNativePlatform()) {
            return;
        }
        this.keyboardShowHandle = await Keyboard.addListener('keyboardWillShow', () => {
            this.keyboardOpen = true;
        });
        this.keyboardHideHandle = await Keyboard.addListener('keyboardWillHide', () => {
            this.keyboardOpen = false;
        });
    }
}
